import { render, staticRenderFns } from "./TypesCount.vue?vue&type=template&id=01e165aa"
import script from "./TypesCount.vue?vue&type=script&lang=js"
export * from "./TypesCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports